const phoneCheckInTokenPath =
  /\/pub\/class-check-in\/phone\/(?!completed(?:[/?#]|$))[^/?#\s]+(\/[^?#\s]*)?(?:[?#][^\s]*)?/g;
const tabletCheckInTokenPath =
  /\/pub\/class-check-in\/(?!phone(?:\/|$)|completed(?:[/?#]|$))[^/?#\s]+(\/[^?#\s]*)?(?:[?#][^\s]*)?/g;
const postTrainingTokenPath =
  /\/pub\/class-post-training\/(?!completed(?:[/?#]|$))[^/?#\s]+(\/[^?#\s]*)?(?:[?#][^\s]*)?/g;
const checkInSessionApiTokenPath =
  /\/classes\/check-in\/session\/[^/?#\s]+(\/[^?#\s]*)?(?:[?#][^\s]*)?/g;
const phoneCheckInSessionApiTokenPath =
  /\/classes\/check-in\/phone-session\/[^/?#\s]+(\/[^?#\s]*)?(?:[?#][^\s]*)?/g;
const postTrainingApiTokenPath =
  /\/classes\/check-in\/post-training\/[^/?#\s]+(\/[^?#\s]*)?(?:[?#][^\s]*)?/g;

export function redactCheckInTokenPaths(value: string): string {
  return value
    .replace(phoneCheckInTokenPath, '/pub/class-check-in/phone/[redacted]$1')
    .replace(tabletCheckInTokenPath, '/pub/class-check-in/[redacted]$1')
    .replace(postTrainingTokenPath, '/pub/class-post-training/[redacted]$1')
    .replace(checkInSessionApiTokenPath, '/classes/check-in/session/[redacted]$1')
    .replace(phoneCheckInSessionApiTokenPath, '/classes/check-in/phone-session/[redacted]$1')
    .replace(postTrainingApiTokenPath, '/classes/check-in/post-training/[redacted]$1');
}

export function containsCheckInTokenPath(value: string | undefined): boolean {
  return value !== undefined && redactCheckInTokenPaths(value) !== value;
}

export function redactCheckInTokens<T>(payload: T): T {
  if (typeof payload === 'string') {
    return redactCheckInTokenPaths(payload) as T;
  }
  if (Array.isArray(payload)) {
    return payload.map(redactCheckInTokens) as T;
  }
  if (payload && typeof payload === 'object') {
    return Object.fromEntries(
      Object.entries(payload).map(([key, value]) => [key, redactCheckInTokens(value)]),
    ) as T;
  }
  return payload;
}
